var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物品名称", prop: "goodsName" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  type: "text",
                  disabled: _vm.isCheck,
                  clearable: "",
                  placeholder: "请输入物品名称"
                },
                model: {
                  value: _vm.childData.goodsName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "goodsName", $$v)
                  },
                  expression: "childData.goodsName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物品类型", prop: "goodsType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "280px" },
                  attrs: {
                    placeholder: "请选择物品类型",
                    disabled: _vm.isCheck,
                    clearable: ""
                  },
                  on: { change: _vm.handleGoodsType },
                  model: {
                    value: _vm.childData.goodsType,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "goodsType", $$v)
                    },
                    expression: "childData.goodsType"
                  }
                },
                _vm._l(_vm.typeOptions, function(item) {
                  return _c("el-option", {
                    key: item.dicValue,
                    attrs: { label: item.typeName, value: item.dicValue }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物品特点", prop: "goodsSpecial" } },
            [
              _c("el-input", {
                staticStyle: { width: "280px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.isCheck,
                  maxlength: "50",
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 2 }
                },
                model: {
                  value: _vm.childData.goodsSpecial,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "goodsSpecial", $$v)
                  },
                  expression: "childData.goodsSpecial"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物品图片" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    name: "files",
                    disabled: _vm.isCheck,
                    "on-error": _vm.handleError,
                    "on-success": _vm.handleSuccess,
                    action: _vm.uploadUrl,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    "before-upload": _vm.beforeUpload,
                    multiple: "",
                    "file-list": _vm.files
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: _vm.isCheck,
                        type: "primary"
                      }
                    },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: { visible: _vm.dialogVisible, title: "预览" },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          !_vm.isCheck
            ? _c("el-button", { on: { click: _vm.handCancle } }, [
                _vm._v(_vm._s(_vm.$t("button.cancel")))
              ])
            : _vm._e(),
          !_vm.isCheck
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }